/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchSubRuleState
 */
export interface SearchSubRuleState {
    /**
     * 
     * @type {string}
     * @memberof SearchSubRuleState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchSubRuleState
     */
    disabled?: boolean;
}

export function SearchSubRuleStateFromJSON(json: any): SearchSubRuleState {
    return SearchSubRuleStateFromJSONTyped(json, false);
}

export function SearchSubRuleStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchSubRuleState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SearchSubRuleStateToJSON(value?: SearchSubRuleState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


